import React from 'react';

const industries = [
  { name: 'Startups', icon: 'fa-rocket', desc: 'Incorporate your Private Limited or LLP company, get DPIIT recognition, and scale with legal compliance.' },
  { name: 'Manufacturers', icon: 'fa-industry', desc: 'Secure factory licenses, environmental clearances, ISO certifications, and FSSAI licenses for production units.' },
  { name: 'Food Businesses', icon: 'fa-utensils', desc: 'Obtain FSSAI registrations and licenses for restaurants, cloud kitchens, caterers, and food packaging units.' },
  { name: 'Retail Businesses', icon: 'fa-shop', desc: 'Secure Shop & Establishment licenses, trade licenses, trademark protection, and local GST registration.' },
  { name: 'E-commerce Sellers', icon: 'fa-cart-shopping', desc: 'Mandatory GST registration, trademark protection for your online brand, and tax return filing services.' },
  { name: 'Exporters & Importers', icon: 'fa-ship', desc: 'Acquire Import Export Code (IEC), customs registration, and international trade policy guidance.' },
  { name: 'Service Providers', icon: 'fa-handshake', desc: 'GST filing, contract drafting, non-disclosure agreements, and professional service tax consultations.' },
  { name: 'Professionals & Consultants', icon: 'fa-user-tie', desc: 'Income tax filing, professional tax registrations, and brand/name trademarking for independent consultants.' },
];

const Solutions = () => {
  return (
    <section id="industries" className="py-5 bg-light position-relative overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        .ind-section {
          font-family: 'Inter', sans-serif;
        }

        .ind-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 24px;
        }

        @media (max-width: 1199px) { .ind-grid { grid-template-columns: repeat(3, 1fr); } }
        @media (max-width: 991px) { .ind-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 575px) { .ind-grid { grid-template-columns: 1fr; } }

        .ind-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 32px 24px;
          border: 1px solid #e2e8f0;
          transition: all 0.25s ease;
          position: relative;
          overflow: hidden;
          text-align: left;
          display: flex;
          flex-direction: column;
        }

        .ind-card::after {
          content: '';
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 4px;
          background: #061830;
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.25s ease;
        }

        .ind-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 16px 32px rgba(15, 23, 42, 0.05);
          border-color: #cbd5e1;
        }

        .ind-card:hover::after {
          transform: scaleX(1);
        }

        .ind-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          background: #e9f2eb;
          color: #061830;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          margin-bottom: 20px;
          transition: all 0.25s;
        }

        .ind-card:hover .ind-icon {
          background: #061830;
          color: #ffffff;
        }

        .ind-title {
          font-size: 17px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 8px;
        }

        .ind-desc {
          font-size: 13.5px;
          color: #64748b;
          line-height: 1.6;
          margin: 0;
        }
      `}</style>

      <div className="container py-4 ind-section">
        {/* Header */}
        <div className="text-center mb-5 pb-2" style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div
            className="d-inline-flex align-items-center gap-2 mb-3 px-4 py-2 rounded-pill shadow-sm"
            style={{
              background: '#fff',
              border: '1px solid #e8edf3',
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '1.2px',
              textTransform: 'uppercase',
              color: '#061830'
            }}
          >
            <span style={{ width: 8, height: 8, background: '#10b981', borderRadius: '50%', boxShadow: '0 0 8px #10b981' }}></span>
            Tailored Industry Solutions
          </div>
          
          <h2 className="display-5 fw-bold mb-4" style={{ color: '#0f172a', letterSpacing: '-1.5px' }}>
            Industries We <span style={{ color: '#061830' }}>Serve</span>
          </h2>
          
          <p className="text-muted" style={{ fontSize: '16px', lineHeight: 1.8 }}>
            Whether you are a local retailer, a fast-growing tech startup, or a global importer, we have specialized legal compliance solutions for your sector.
          </p>
        </div>

        {/* Grid */}
        <div className="ind-grid">
          {industries.map((ind, i) => (
            <div key={i} className="ind-card">
              <div className="ind-icon">
                <i className={`fa-solid ${ind.icon}`}></i>
              </div>
              <h5 className="ind-title">{ind.name}</h5>
              <p className="ind-desc">{ind.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
